import { SearchResultPartyDetails } from '@Entities/party-details'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'
import React from 'react'
import { UseFormRegister } from 'react-hook-form'

interface PublisherSelectorDetailCardProps {
    partyDetails: SearchResultPartyDetails
    onTitleClick: (partyDetails: SearchResultPartyDetails) => void
    register: UseFormRegister<{ party: string }>
}

const PublisherSelectorDetailCard = ({ partyDetails, onTitleClick, register }: PublisherSelectorDetailCardProps) => (
    <SearchResultPartyDetailsCard partyDetails={partyDetails} onTitleClick={onTitleClick}>
        <div className="radio-button-wrapper">
            <input type="radio" value={partyDetails.ipId || ''} {...register('party', { required: true })} />
        </div>
    </SearchResultPartyDetailsCard>
)

export default PublisherSelectorDetailCard
